import { Grid } from '@mui/material';
import { t } from 'i18next';
import ControlledDatePicker from '../form/controlledDatePicker';

export const OrganizationTitleEditDate = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <ControlledDatePicker name='admDate' label={t('common:organization.admDate')} disableFuture />
      </Grid>
      <Grid item xs={6}>
        <ControlledDatePicker name='resDate' label={t('common:organization.resDate')} disableFuture />
      </Grid>
    </Grid>
  );
};
